<template>
  <v-card class="pa-0 mb-3 dashboard-card">
    <v-list three-line class="pa-0 ma-0">
      <v-list-item>
        <v-list-item-avatar size="80" class="mt-0 pt-0 mt-3" justify align="center">
          <v-img :lazy-src="badge.iconLink" :src="badge.iconLink"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="card-list-title font-weight-regular">
            {{ badge.title }}
            <span v-if="showChallenge && badge.blockChallenge" class="font-14">
              - {{ badge.blockChallenge.title }} users only
            </span>
            <span v-else-if="showChallenge && badge.challenge" class="font-14">
              - {{ badge.challenge.title }} users only
            </span>
            <span v-else-if="showChallenge && badge.corporateChallenge" class="font-14">
              - {{ badge.corporateChallenge.title }} users only
            </span>
            <v-spacer />
          </v-list-item-title>
          <v-list-item-subtitle v-if="showEvent" class="mt-n2">
            <strong>{{ event }}</strong>
          </v-list-item-subtitle>
          <v-list-item-subtitle>{{ badge.description }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div v-if="showWeeksQualifier" class="ml-6 d-flex align-baseline">
      <v-card-title>How to earn:</v-card-title>
      <span class="font-weight-bold"> {{ weeks }} weeks on track </span>
    </div>
    <div v-if="showQualifiers" class="ml-6">
      <div class="d-flex">
        <v-tooltip right max-width="150">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="grey" v-bind="attrs" v-on="on" class="mt-1 ml-n3">
              mdi-information
            </v-icon>
          </template>
          <span>
            Overlapping categories become redundant. [exercise: 5] and [any: 5] will be awarded to any client that logs
            5 dots;
            <strong>not 10 dots</strong>
          </span>
        </v-tooltip>
        <v-card-title class="pb-2 pl-2">How to earn:</v-card-title>
      </div>
      <v-card-subtitle class="py-0">
        <ul>
          <li v-for="(qualifier, index) in qualifiers" :key="index">
            {{ qualifier.quantity }} {{ qualifier.activityType }} dots
          </li>
        </ul>
      </v-card-subtitle>
      <v-card-subtitle v-if="qualifiers && qualifiers.length == 0" class="py-0 pl-5">
        No criteria
      </v-card-subtitle>
    </div>
    <v-card-actions>
      <v-card-subtitle class="ml-5"> {{ badge.userCount }} users have this badge </v-card-subtitle>
      <div class="d-flex flex-column ml-auto mr-4">
        <v-card-subtitle v-if="showDates" class="d-flex ml-auto px-0">
          {{ badge.startDate | formatDate }} - {{ badge.endDate | formatDate }}
        </v-card-subtitle>
        <div class="d-flex ml-auto">
          <v-checkbox v-if="showEnabled" :input-value="badge.isEnabled" readonly label="Enabled" class="mr-5 mt-0" />
          <v-btn @click="editBadge()">
            Edit
          </v-btn>
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { SIMPLE_EVENT_QUERY } from "@/constants/graphql/badges/badge";
import { YYYYMMDD_readable } from "@/lib/fancy_date";
import BadgeDisplayMixin from "./mixins/BadgeDisplayMixin";

export default {
  name: "BadgeCard",
  props: {
    badge: {
      type: Object,
      required: true,
    },
  },
  mixins: [BadgeDisplayMixin],
  computed: {
    qualifiers() {
      return JSON.parse(this.badge.functionValues)?.qualifiers;
    },
    weeks() {
      return JSON.parse(this.badge.functionValues)?.weeks;
    },
  },
  methods: {
    editBadge() {
      this.$emit("edit");
    },
  },
  filters: {
    formatDate(date) {
      if (date) return YYYYMMDD_readable(date);
      else {
        return "";
      }
    },
  },
  apollo: {
    event: {
      query: SIMPLE_EVENT_QUERY,
      variables() {
        return {
          id: JSON.parse(this.badge.functionValues)?.eventId,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        let date = this.$moment(data.event.scheduledDate).format("YYYY-MM-DD");
        let time = this.$moment(data.event.startTime, "HH:mm:ss").format("HH:mm");

        return `${date} ${time}: ${data.event.name}`;
      },
      skip() {
        return !this.showEvent;
      },
    },
  },
};
</script>

<style scoped>
.font-14 {
  font-size: 14px;
}
</style>
